var path = '/Users/saulsoto/Documents/workspace/spa/spa-frontend/src/components/navigation/navigation.html';
var html = "<div id=page-sidebar style=height:3000px;clear:both> <div class=scroll-sidebar style=height:3000px> <ul id=sidebar-menu class=\"sf-js-enabled sf-arrows\"> <li ng-repeat-start=\"node in vm.nodes | filter: vm.search\" class=header> <span ng-if=!vm.isEmpty(node)>{{node.header}}</span> </li> <li ng-repeat=\"item in node.nodes | filter: vm.search\"> <a auth some-permissions=item.permissions ui-sref={{item.sref}} ui-sref-active=sfActive> <i ng-class=item.classes></i> <span>{{item.text}}</span> </a> </li> <span ng-repeat-end></span> </ul> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/components/navigation/navigation.html
// module id = 965
// module chunks = 0